module.exports = __webpack_public_path__ + "img/booth_kfqNew.13023018.png";